package ru.villawonka.app.presentation.screens.splash.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.NetworkFailure

sealed interface SplashUIState : UIState {

    data class Error(val failure: NetworkFailure) : SplashUIState
    
    data object Loading : SplashUIState
}